export default class UsersController {
    /** @ngInject */
    constructor(UsersApi, RolesApi, Loader, DialogService, $timeout) {
        this.UsersApi = UsersApi;
        this.RolesApi = RolesApi;
        this.Loader = Loader;
        this.DialogService = DialogService;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.users = [];
        this.roles = [];
        this.selectedUsers = [];
        this.selectedRole = null;

        this.query = '';

        this.hasRoles = false;
        this.inProgress = false;
        this.showAddUser = false;

        this.loadUsers();
        this.loadRoles();
    }

    startProgress() {
        this.inProgress = true;
        this.Loader.show();
    }

    stopProgress() {
        this.inProgress = false;
        this.Loader.hide();
    }

    loadUsers(query) {
        this.startProgress();

        let promise;
        if (query && query.length) {
            promise = this.UsersApi.search(query);
        } else {
            promise = this.UsersApi.getList();
        }

        return promise.then((data) => {
            this.users = data.users || [];

            this.stopProgress();

            return this.users;
        }, () => {
            this.users = [];

            this.stopProgress();

            return this.users;
        });
    }

    loadRoles() {
        return this.RolesApi.getList().then((data) => {
            this.roles = data.roles || [];
            this.hasRoles = this.roles.length;

            return this.roles;
        }, () => {
            this.roles = [];
            this.hasRoles = false;

            return this.roles;
        });
    }

    onCreateNewUserClick() {
        this.showAddUser = !this.showAddUser;
    }

    onSearchInputActivate() {
        this.showAddUser = false;
    }

    onSearchInputDeactivate() {
        this.showAddUser = false;
    }

    onSearch({ query }) {
        this.query = query;

        this.loadUsers(query);
    }

    resetSearch() {
        this.query = '';

        this.loadUsers();
    }

    onUserCreate({ user }) {
        this.startProgress();

        this.UsersApi.createUser(user).then(() => {
            this.loadUsers();

            this.showAddUser = false;
        }, () => {
            this.stopProgress();
        });
        // TODO: add toast for error
    }

    onCancelUserCreate() {
        this.showAddUser = false;
    }

    onUserDelete(user) {
        this.startProgress();

        this.showAddUser = false;

        this.UsersApi.deleteUser(user.id).then(() => {
            this.users = this.users.filter(localUser => localUser.id !== user.id);
            this.stopProgress();
            // TODO: refactor when elastic will work correctly with cache
            // this.loadUsers();
        }, () => {
            this.stopProgress();
        });
        // TODO: add toast for error
    }

    onUserResetPassword(user) {
        this.startProgress();

        this.showAddUser = false;

        this.UsersApi.resetPassword(user.id).then(() => {
            this.stopProgress();
            // TODO: refactor when elastic will work correctly with cache
            // this.loadUsers();
        }, () => {
            this.stopProgress();
        });
        // TODO: add toast for error
    }

    onAssignRole($event) {
        if (!this.selectedRole || !this.selectedUsers || !this.selectedUsers.length) return;

        this.DialogService.confirm({
            title: 'Assign Role',
            textContent: `Would you like to assign role "${this.selectedRole.name}" to selected users?`,
            ariaLabel: 'assign-role',
            targetEvent: $event,
            ok: 'Assign',
            cancel: 'Cancel'
        }).then(() => {
            this.startProgress();

            this.showAddUser = false;

            this.RolesApi.addUsersToRole(this.selectedRole.id, this.selectedUsers.map(user => user.id)).then(() => {
                // TODO: refactor when elastic will work correctly with cache
                this.$timeout(() => {
                    this.loadUsers();
                }, 1000);
            }, () => {
                this.stopProgress();
            });
            // TODO: add toast for error
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/users-and-access/users/users.controller.js